import { TrendingUp, TrendingDown } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { useNavigate } from 'react-router-dom';

export function TopMoversWidget({ topMovers, loading }) {
  const navigate = useNavigate();

  if (loading) {
    return (
      <Card className="gds-card">
        <CardHeader>
          <CardTitle className="font-heading text-sm flex items-center gap-2">
            <TrendingUp className="w-4 h-4 text-indigo-500" />
            Top Keyword Movers
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-2">
            {[...Array(3)].map((_, i) => (
              <div key={i} className="h-10 rounded-lg bg-slate-100 dark:bg-slate-800 animate-pulse" />
            ))}
          </div>
        </CardContent>
      </Card>
    );
  }

  if (!topMovers) {
    return (
      <Card className="gds-card">
        <CardHeader>
          <CardTitle className="font-heading text-sm flex items-center gap-2">
            <TrendingUp className="w-4 h-4 text-indigo-500" />
            Top Keyword Movers
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-slate-500 text-center py-4">
            Connect Google Search Console to track keyword movement
          </p>
        </CardContent>
      </Card>
    );
  }

  const Row = ({ item, direction }) => (
    <div
      className="flex items-center justify-between p-2.5 rounded-lg hover:bg-slate-50 dark:hover:bg-slate-800/50 cursor-pointer transition-colors"
      onClick={() => navigate('/dashboard/keywords')}
    >
      <div className="flex items-center gap-2 min-w-0">
        {direction === 'up' ? (
          <TrendingUp className="w-4 h-4 text-emerald-500 flex-shrink-0" />
        ) : (
          <TrendingDown className="w-4 h-4 text-red-400 flex-shrink-0" />
        )}
        <span className="text-sm truncate">{item.keyword}</span>
      </div>
      <div className="flex items-center gap-2 flex-shrink-0">
        <span className="text-xs text-slate-500">pos {item.position}</span>
        <span className={`text-xs font-medium ${direction === 'up' ? 'text-emerald-600' : 'text-red-500'}`}>
          {direction === 'up' ? '+' : ''}{item.change}
        </span>
      </div>
    </div>
  );

  return (
    <Card className="gds-card">
      <CardHeader>
        <CardTitle className="font-heading text-sm flex items-center gap-2">
          <TrendingUp className="w-4 h-4 text-indigo-500" />
          Top Keyword Movers (30d)
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-1">
        {topMovers.up?.length > 0 && (
          <div>
            <p className="text-xs font-medium text-slate-400 mb-1 px-2.5">Improved</p>
            {topMovers.up.map((item, i) => (
              <Row key={i} item={item} direction="up" />
            ))}
          </div>
        )}
        {topMovers.down?.length > 0 && topMovers.down.some(d => d.change < 0) && (
          <div className="mt-2">
            <p className="text-xs font-medium text-slate-400 mb-1 px-2.5">Dropped</p>
            {topMovers.down.filter(d => d.change < 0).map((item, i) => (
              <Row key={i} item={item} direction="down" />
            ))}
          </div>
        )}
        {(!topMovers.up?.length && !topMovers.down?.filter(d => d.change < 0).length) && (
          <p className="text-sm text-slate-500 text-center py-4">No keyword changes in the last 30 days</p>
        )}
      </CardContent>
    </Card>
  );
}
